module.exports = __webpack_public_path__ + "static/media/BreakTesting.f77709ff.svg";